import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewActivity = (page = 1, limit = 10) => { 
    return useQuery({ 
        queryKey: ['viewActivityReport', page, limit], 
        queryFn: async () => { 
            const res = await api.get('/auditlogs', {
                params: { page, limit }
            }); 
            return res.data; 
        },
        placeholderData: keepPreviousData,
     });
};  